module.exports = __webpack_public_path__ + "static/img/cont33_04.595cfef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont33_04.jpg
// module id = fqDu
// module chunks = 0